import i18n from '@/locales';
import { createApp } from 'vue';
import BuildingPurchaseBrowsing from '@/components/purchase/BuildingPurchaseBrowsing.vue';

const app = createApp({});
app.use(i18n);
app.component('BuildingPurchaseBrowsing', BuildingPurchaseBrowsing);
app.mount('#buildingPurchaseBrowsingApp');
